<template>
    <v-container fill-height>
    <v-layout justify-center align-center>
        <v-flex class="mt-auto mb-auto" xs12 sm10 md6 lg5 xl4> 
        <div id="login">
            <v-card class="text-center ma-auto ">
                <v-card-title>
                    <v-row  class="justify-center no-gutters mt-4">
                        <div id="avatar">
                            <v-img src=""></v-img>       
                        </div>
                    </v-row>
                </v-card-title>
                <v-row class="justify-center no-gutters ma-4">
                    <v-col cols="12">
                        <p class="text-center subtitle-1" color="rgba(0, 0, 0, 0.54)"><strong>Zaloguj się</strong> do serwisu race-app.eu</p>
                        <v-form v-model="valid" @submit.prevent="login">
                            <v-text-field 
                                v-model="vLogin"
                                class="mb-n5" 
                                outlined
                                color="#b2d234" 
                                label="Login" 
                                prepend-inner-icon="person"
                                clearable
                                clear-icon="close"
                                @click:clear="this.vLogin=''"
                                readable                 
                            ></v-text-field>
                            <v-text-field 
                                v-model="vPassword" 
                                class="mb-n2" 
                                outlined 
                                color="#b2d234" 
                                label="Hasło" 
                                prepend-inner-icon="lock"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPassword ? 'text' : 'password'"
                                @click:append="showPassword = !showPassword"
                                clearable
                                clear-icon="close"
                                @click:clear="this.vPassword=''"
                                readable
                            ></v-text-field>
                            <v-btn  
                                :loading="loading2"
                                :disabled="loading2" 
                                color="#b2d234" class="white--text" large block type="submit" name="button">
                                <v-icon>check</v-icon>
                                <span>logowanie</span>
                            </v-btn>
                            <template v-slot:loader>
                                    <span>Loading...</span>
                                </template>
                        </v-form>
                        <v-divider color="#b2d234" class="mt-6 mb-4" />
                        <div class="pt-2 pb-4" >
                            <div class="text-center caption">
                                <p>Kliknij jeśli 
                                    <router-link to='/'><a>nie pamiętasz hasła</a></router-link>
                                    lub 
                                    <router-link to='/'><a>nie masz konta</a></router-link>
                                </p>
                            </div>
                        </div>
                        <div class="pt-2 pb-4" >
                            <div class="text-right overline">
                                <p>Copyright 2020 DiDevelopment & Laczek </p>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </div>
        </v-flex>
        </v-layout>
        <v-snackbar v-model="snackbar">
            {{ error }}
            <v-btn
                color="pink"
                text
                @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
    </v-container>
</template>
<style scoped>

</style>
<script>
import { authComputed } from '../store/helper.js'
//import $api from '../libs/race-app.js'
export default {
    name:"login",
    data(){
        return{
            valid:true,
            vLogin:'string',
            vPassword:'string',
            loader:null,
            loading2:false,
            token:null,
            showPassword:false,
            error:'',
            snackbar:false
        }
    },
    computed:{
        ...authComputed
    },
    beforeCreate:function(){
      sessionStorage.login_active = false;
    },
    mounted(){
        localStorage.setItem('login',null)
        localStorage.setItem('password',null)
        localStorage.setItem('token',null)
        localStorage.setItem('stan',null)
    },
    methods:{
        login(){
            var aes256 = require('aes256');
            var key = 'd41d8cd98f00b204e9800998ecf8427e';
            
            /*
                na podstawie linku:
                - localhost -> przenosi dalej
                - web -> korzyszta z API
            */
            if(window.location.href.indexOf("localhost")){
                this.$router.push({name:'dashboard'})
            }else{
                this.$store.dispatch('login',{
                login: aes256.encrypt(key,this.vLogin),
                password: aes256.encrypt(key,this.vPassword)
                })
                .then(()=> {
                    this.$router.push({name:'dashboard'})
                })
                .catch(err => {
                    this.serverStatus = err.response.status;
                    this.serverCases(this.serverStatus);
                    this.snackbar=true;
                    console.log(this.error)
                })
            }
            
            
            // logowanie przez zewnetrzny plik api 
            // if(this.vLogin && this.vPassword){
            //     localStorage.login = aes256.encrypt(key,this.vLogin);
            //     localStorage.password = aes256.encrypt(key,this.vPassword);
            //     sessionStorage.login = aes256.encrypt(key,this.vLogin);
            //     sessionStorage.password = aes256.encrypt(key,this.vPassword);
            //     $api.login();
            // }
        },
        serverCases(status){
            switch (status) {
                default:
                    this.error = "Błąd!";
                    break;
                case 500:
                    this.error = "Błędne dane do logowania";
                    break;
                case 401:
                    this.error = "Brak autoryzacji";
                }
        } 
    },
}
</script>